import { Carousel } from 'antd';
import React from 'react';
import SectionHeader from '../SectionHeader/SectionHeader';
import AuthorCard from './AuthorCard';

function AuthorCarousel({
  sectionHeading,
  headerLink,
  headerDescription,
  data = [],
  responsive
}) {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 2,
    variableWidth: true,
    draggable: true,
    loop: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };
  return (
    <section
      className={`author-carousel ${responsive ? 'responsive-view' : ''}`}
    >
      <div className="container">
        <SectionHeader
          heading={sectionHeading}
          headerLink={headerLink}
          headerDescription={headerDescription}
        />
      </div>
      <div className="one-side-carousel shadow-arrow">
        <Carousel {...settings}>
          {data?.map((item) => {
            return (
              <div key={item?.id}>
                <AuthorCard
                  href={item?.href}
                  speaker={item?.speaker}
                  videoCount={item?.videoCount}
                  image={item?.url}
                  blurHash={item.blurHash}
                />
              </div>
            );
          })}
        </Carousel>
      </div>
    </section>
  );
}
export default AuthorCarousel;
